export let Breakdown = /*#__PURE__*/function (Breakdown) {
  Breakdown["Service"] = "service";
  Breakdown["Customer"] = "customer";
  return Breakdown;
}({});
export let FilterType = /*#__PURE__*/function (FilterType) {
  FilterType["CustomerName"] = "company";
  FilterType["ServiceName"] = "service";
  FilterType["DateRange"] = "dateRange";
  FilterType["Aggregate"] = "aggregate";
  FilterType["Breakdowns"] = "breakdowns";
  return FilterType;
}({});